// Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import classNames from 'classnames';

// Utils, misc
import * as Actions from 'actions/sniplets';
import sanitize, { isMarkup } from 'utils/sanitize';

const dateFormat = 'MMM DD, YYYY hh:mm:ss A';

if (process.env.NODE_ENV !== 'test') {
  require('./Sniplet.scss');
}

class Sniplet extends Component {
  componentWillMount() {
    const { dispatch, sniplets } = this.props;
    const actions = bindActionCreators(Actions, dispatch);
    this.actions = actions;

    // Look for fresh data if we don't have any sniplets
    if (!sniplets || (!sniplets.isFetching && !sniplets.data.size)) {
      actions.fetchData();
    }
  }

  snipletPublished(sniplet) {
    if (!sniplet) return false;

    const now = moment();
    const from = sniplet.get('publishedFrom');
    const to = sniplet.get('publishedTo');
    return (
      sniplet.get('published') &&
      (!from ||
        moment(from, dateFormat, 'en')
          .startOf('day')
          .isBefore(now)) &&
      (!to ||
        moment(to, dateFormat, 'en')
          .endOf('day')
          .isAfter(now))
    );
  }

  render() {
    const { data } = this.props.sniplets;

    const sniplet = data.find(snip => snip.get('name') === this.props.name);
    const body = sniplet && sniplet.getIn(['bodies', 'NO', 'body']);
    const emptyBody = !body || body === '<div><br></div>';

    // If no sniplet is found, do not render
    // If sniplet is found, but empty (quill editor empty === div with br),
    // then do not render
    return !sniplet || !this.snipletPublished(sniplet) || emptyBody ? null : (
      <div
        className={classNames('Sniplet', this.props.name, this.props.className)}
      >
        {!isMarkup(body) ? (
          body
        ) : (
          <div dangerouslySetInnerHTML={sanitize(body)} />
        )}
      </div>
    );
  }
}

function mapStateToProps({ sniplets }) {
  return { sniplets };
}

export { Sniplet };
export default connect(mapStateToProps)(Sniplet);
